<template>
  <!-- 新日账单明细 -->
  <div class="home-page-container">
    <!-- search 查询 -->
    <el-card shadow="never">
      <mer-search :searchConfig="formConfig" :searchBar="searchBar"
        @search="search"
        @reset="reset(initQuery, 'searchBar', {type: 'clickEvent', name: '结算账单明细（非油品）重置', id: '1621476408'})"
        @changeTime="(value,model)=>changeTime(
          value,
          'searchBar',
          'orderSettlementTimeStart',
          'orderSettlementTimeEnd')"
        :loading="tableLoading">
        <template slot="handler">
          <download-button :downloadApi="downloadDailyBillNoOilApi" :queryParams="{ ...downloadParams }" style="margin-right: 10px;"></download-button>
          <!-- <el-button size="mini" @click="gotoOldDetail">8月4日前账单明细 >>></el-button> -->
        </template>
      </mer-search>
    </el-card>
    <!-- summary 汇总信息 -->
    <sum-panel :labelMap="sumLabel" :sumInfo="sumInfo" :tipsInfo="tipsInfo"></sum-panel>
    <!-- table 表格 -->
    <el-card shadow="never">
      <mer-table :loading="tableLoading"
        :tableConfig="tableConfig"
        :tableData="tableData"
        :pagination="pagination"
        @SizeChange="handleSizeChange"
        @PageChange="pageChange"
        :hasIndex="false">
      </mer-table>
    </el-card>
  </div>
</template>
<script>
import listPage from '@/mixins/listPage'
import queryMix from '@/views/finance/mixins/query';
import SumPanel from '@/views/finance/components/bill/SumPanel'
import { getDailyDetailQueryApi, downloadDailyBillNoOilApi } from '@/api/finance'
import { nonOilDetailList, nonOilDetailSummary } from '@/api/finance/nonOil'
import { getOilNumList } from '@/api/order'
import config from './config/unoilDailyBillDetail'

export default {
  name: 'unoilDailyBillDetail',
  mixins:[ listPage, queryMix ],
  data(){
    return {
      downloadDailyBillNoOilApi,
      ...config,
      tableData: {},
      tradeTime:'',
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = ''
          }
        },
        // 限制时间选择范围32天
        disabledDate: (time) => {
          if (this.selectDate !== '') {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      }
    }
  },
  created(){
    // 获取商户ID（vuex或者sessionStorage）
    this.initPage()
  },
  methods:{
    initPage () {
      this.initQuery()
      this.getAllQueryProps()
      this.getAllOil()
      this.refresh()
      // this.initList(nonOilDetailList,true,nonOilDetailSummary)
    },  
    // 设置默认查询条件，默认时间间隔2天
    initQuery () {
      this.tradeTime = ''
      this.initTime('tradeTime', 1, 'searchBar', false, 'orderSettlementTimeStart', 'orderSettlementTimeEnd')
      const { tradeTime, pickerOptions } = this
      const initObj = { tradeTime: [tradeTime, pickerOptions] }
      this.setSearchConfig(initObj)
    },
    getAllQueryProps(){
      this.getQueryStatus()
      //获取油站
      this.getAllGasStations()
    },
    // 获取查询条件：交易类型
    async getQueryStatus () {
      try{
        const { code, result = [] } = await getDailyDetailQueryApi()
        if(code !== 200) return
        const initObj = { orderType: this.optionsWrapper(result) }
        this.setSearchConfig(initObj)
      }catch(err){
        console.log(err)
      }
    },
    //导出
    // download () {
    //   this.downloadFile(downloadDailyDetailListApi,'结算日账单明细')
    // },
    gotoOldDetail(){
      this.$router.push({path:'/bill/oldBillDetailList'})
    },
    // 获取table ||  特殊的请求或数据处理，可以覆写该方法
    async refresh () {
      this.tableLoading = true
      const data = { ...this.searchBar, ...this.pagination }
      //对查询条件做一次缓存
      this.downloadParams = { ...this.searchBar }
      this.getSumInfo(data)
      try{
        const { code, result = [], totalRow = 0 } = await nonOilDetailList(data)
        if(code !== 200) return
        this.tableData.records = result
        this.tableData.total = parseInt(totalRow)
      }catch(err){
        console.log(err)
      }finally{
        this.tableLoading = false
      }
    },
    // 列表汇总（统计）信息
    async getSumInfo (data) {
      try{
        const { code, result } = await nonOilDetailSummary(data)
        if(code !== 200) return
        this.sumInfo = result
      }catch(err){
        console.log(err)
      }
    },
    async getAllOil(){
      try{
        const {code,result} = await getOilNumList()
        if(code !==200) return
        const initObj = { oilNo: result || [] }
        this.setSearchConfig(initObj)
      }catch(e){
        console.log(e)
      }
    }
  },
  components: {
    SumPanel
  }
}
</script>
<style lang="less" scoped>
.home-page-container{
  margin-top: 20px;
}
</style>
